import { ajax } from '../../utils/ajaxHandler';
import { get, addLineBreaks } from '../../utils/objectHelpers';

const AJAX_TIMEOUT = 10000;

export default class {
    onCreate(input) {
        const tab1 = get(input, 'regionsData.TAB1', []);
        const storePolicies = tab1.find(m => m.meta && m.meta.name === 'ABOUT_STORE_POLICIES');
        this.fetchStarted = false;
        this.url = get(storePolicies, 'action.URL');
        const sections = get(storePolicies, 'sections', []);
        sections.forEach(el => {
            el.isOpen = false;
        });
        this.state = {
            sections: sections,
            policies: {}
        };
    }
    fetchPolicies(evt) {
        this.toggleSectionOpen(evt);

        // Fetch policies
        if (evt.open && !this.fetchStarted && !Object.keys(this.state.policies).length) {
            this.fetchStarted = true;
            const ajaxUrl = buildAjaxUrl(this.url);
            if (ajaxUrl) {
                ajax({ url: ajaxUrl }, {
                    successCallBack: (resp) => {
                        this.setPolicies(resp);
                        this.fetchStarted = false;
                    },
                    errorCallBack: () => {
                        this.toggleSectionOpen(evt, false); // close section
                        this.fetchStarted = false;
                    }
                }, AJAX_TIMEOUT);
            }
        }
    }
    setPolicies(resp) {
        const policies = get(resp, 'modules.STORE_POLICY_DESCRIPTION_MODULE.policies');
        if (policies) {
            for (const key in policies) {
                if (policies.hasOwnProperty(key)) {
                    const value = policies[key];
                    this.state.policies[key] = addLineBreaks(value);
                }
            }
            this.setStateDirty('policies');
        }
    }
    // Handle open and close state of section
    toggleSectionOpen(evt, isOpen) {
        const policyType = evt.originalEvent.target.querySelector('.policy-type');
        if (policyType) {
            const section = this.state.sections.find(sect => {
                const pt = get(sect, 'action.params.policyTypes', '');
                return pt === policyType.value;
            });
            section.isOpen = typeof isOpen !== 'undefined' ? isOpen : evt.open;
            this.setStateDirty('sections');
        }
    }
}

// The 'url' argument looks like:
// https://storefrontsvc.vip.qa.ebay.com/experience/storefront/v1/module_provider?storeName=vstrfashion&moduleGroups=STORE_POLICY_DESCRIPTION_MODULE&policyTypes=SHIPPING%2CRETURN%2CWARRANTY
function buildAjaxUrl(url) {
    if (url) {
        const link = document.createElement('a');
        link.href = window.location.href;
        const paths = link.pathname.split('/');
        const urlParts = url.split('?');

        if (paths.length > 2 && urlParts.length === 2) {
            const ajaxUrl = `${link.origin}/str/${paths[2]}?${urlParts[1]}&_ajax=policy`;
            return ajaxUrl;
        }
    }
}
